import React, { lazy, Suspense } from 'react';
import CareInstructionList from './CareLabels/CareInstructionList';
import CareUserInstructionStateProvider from './CareLabels/CareLabelProvider/CareUserInstructionStateProvider';
import Loader from '../../Components/Utility/Loader/Loader';

const BomList = lazy(() => import('./Bom/BomList'));
const Measurement = lazy(() => import('./Measurment/Measurement'));

function DevlopmentOrderWrapper(props) {
  const { type } = props;
  const renderValues = () => {
    switch (type) {
      case 'bom':
        return (
          <Suspense fallback={<Loader />}>
            <BomList {...props} />
          </Suspense>
        );

      case 'measurement':
        return (
          <Suspense fallback={<Loader />}>
            <Measurement {...props} />
          </Suspense>
        );

      case 'care-user-instruction':
        return (
          <CareUserInstructionStateProvider>
            <CareInstructionList {...props} />{' '}
          </CareUserInstructionStateProvider>
        );
      default:
        return null;
    }
  };
  return renderValues();
}

export default DevlopmentOrderWrapper;
